module.exports = {
      id: "mast-logo-usage",
      viewBox: "0 0 350 51",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#mast-logo",
      toString: function () {
        return this.url;
      }
    }